import React, { useEffect, useState } from 'react'
import { IoMdCheckmarkCircleOutline } from "react-icons/io";
import { useLocation, useNavigate } from 'react-router-dom';
import { RiInformationLine } from "react-icons/ri";


const ThankyouPage = () => {

    const navigate = useNavigate();
    const location = useLocation();
    const [countdown, setCountdown] = useState(29);

    useEffect(() => {
        // Redirect to home if no location state is available
        if (!location.state || !location.state.status) {
            navigate("/", { replace: true });
        }

        // Start countdown
        const timer = setInterval(() => {
            setCountdown((prevCount) => {
                if (prevCount <= 1) {
                    clearInterval(timer); // Stop the timer when countdown reaches 0
                    navigate("/", { replace: true }); // Redirect to homepage
                    return 0;
                }
                return prevCount - 1; // Decrease the countdown
            });
        }, 1000);

        // Cleanup timer on unmount
        return () => clearInterval(timer);
    }, [location, navigate]);

    return (
        <div className="thank-you-page sec-eleven-about bg-light">
            {location.state && location.state.status === 'success' ? (<div className="thank-you-content">
                <IoMdCheckmarkCircleOutline />
                <h1>Thank you!</h1>
                <p>Thank you for registering for our webinar. We will get back to you soon.</p>
                <p className="text-muted">
                    You will be redirected to the homepage in <strong>{countdown} seconds</strong>.
                </p>
                <div className='mt-4 button-pane'>
                    <button className="btn btn-primary" onClick={() => navigate("/")} >
                        Go to Homepage
                    </button>
                </div>
            </div>) : (

                <div className='thank-you-expired'>
                    <RiInformationLine />
                    <h1>Your Registration is already submitted or expired</h1>
                    <div className='mt-4 button-pane'>
                        <button className="btn btn-primary" onClick={() => navigate("/")} >
                            Go to Homepage
                        </button>
                    </div>
                </div>
            )}

        </div>
    )
}

export default ThankyouPage